import moment from 'moment';

import { timelineDataConfig } from '../../../../shared/helpers';

const areAllObligatoryMilestonePasses = (steps) =>
  steps.every(({ isPassed, isObligatory }) => !isObligatory || isPassed);

const getDateDisregardingTime = (date) =>
  moment(date).startOf('day');

const getDateFromStartInIsoString = (date) =>
  getDateDisregardingTime(date).toISOString();

const getDaysLeft = (deadlineDate) =>
  Math.floor(
    moment
      .duration(getDateDisregardingTime(deadlineDate).diff(getDateDisregardingTime(new Date())))
      .asDays(),
  );

const getDate = (date) => {
  const [day, month, year] = moment(date).format('DD MMM YYYY').split(' ');
  return { day, month, year };
};

const getCurrentMilestoneIndex = (items) =>
  items.find(({ isCurrentMilestone }) => isCurrentMilestone)?.index;

const getCurrentMilestoneName = (timelineData) => (
  timelineDataConfig
    .find((timelineItem) => timelineItem.steps.some(({ date, isObligatory }) => isObligatory && !date(timelineData)))
      || timelineDataConfig[timelineDataConfig.length - 1]
)?.name;

export {
  areAllObligatoryMilestonePasses,
  getDaysLeft,
  getCurrentMilestoneIndex,
  getDate,
  getDateFromStartInIsoString,
  getCurrentMilestoneName,
};
